
import { getPostList } from '@/api/post';
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';

@Component({
  components: {
    Pagination,
  },
})
export default class extends Vue {
  mounted() {
    this.getPostList();
  }

  private loading = true;

  private listQuery = {
    page: 1,
    size: 10,
    boardUid: '74f59e08-cf5e-42ed-ae3e-781ba429d88c',
    businessStatus: true,
  };

  private postList: any = [];

  private totalElements = 0;

  private getPostList() {
    this.loading = true;
    getPostList(this.listQuery).then((res) => {
      this.loading = false;
      this.postList = res.data.content;
      this.totalElements = res.data.totalElements;
    });
  }

  private handleClickPost(uid: any) {
    this.$router.push({ name: 'InquiryDetail', params: { uid } });
  }
}
